<template>
  <div>
    <v-treeview
      :items="articles"
      item-text="title"
      open-all
      hoverable
      activatable
      @update:active="select_item"
    >
      <template #prepend>
        <v-icon>
          {{ "mdi-book" }}
        </v-icon>
      </template>
    </v-treeview>
  </div>
</template>

<script>
import { useArticlesStoreRefactor } from "@/stores/articlesStoreRefactor";

export default {
  name: "ArticleNavigation",
  computed: {
    articles() {
      const articlesStore = useArticlesStoreRefactor();
      return articlesStore.data.filter((article) => article.parent_id === null);
    },
  },
  methods: {
    select_item: function (x) {
      this.$emit("selected_item", x[0]);
    },
  },
};
</script>
